import React from 'react'
import { MountSmartviewOnPipe } from '@morningtrain/react-smartviews'
import NormsSummarySmartview from 'widgets/smartviews/inventory/NormsSummarySmartview'
import { OnNavigatePipeline } from '@morningtrain/react-navigation'
import { useForm } from '@morningtrain/react-resources'

export default function MountNormsSummarySmartview () {
  const form = useForm()

  return (
    <OnNavigatePipeline>
      <MountSmartviewOnPipe smartview={<NormsSummarySmartview form={form} />} replace />
    </OnNavigatePipeline>
  )
}
